import { SEPARATOR } from '@hakimo-ui/hakimo/data-access';
import { DoorGroup, DoorGroupFilters } from '@hakimo-ui/hakimo/types';
import { Column as TableColumn, TableData } from '@hakimo-ui/hakimo/ui-table';

export const columns: TableColumn[] = [
  {
    id: 'name',
    name: 'Name',
  },
  {
    id: 'description',
    name: 'Description',
    showAtBreakpoint: 'sm',
  },
];

export function getTableData(items: DoorGroup[]): TableData {
  return {
    rows: items.map((door_groups) => {
      return {
        id: String(door_groups.id),
        cells: [
          {
            value: door_groups.name,
          },
          {
            value: door_groups.description,
          },
        ],
      };
    }),
    columns,
  };
}

export function getSearchParams(
  page: number,
  filters: DoorGroupFilters,
  pageSize: number
): string {
  const params = new URLSearchParams();
  params.append('page', String(page));
  params.append('pageSize', String(pageSize));

  // name filter is not yet there in the backend API, but adding support here.
  if (filters.name.values.length > 0) {
    params.append(
      'name',
      filters.name.values.map((item) => item.name).join(SEPARATOR)
    );
  }

  return params.toString();
}
